import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from 'components/@mui-extend/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Forms from 'components/forms'
import ImgFondoProveedor from 'assets/images/Img_Fondo_Proveedor.jpg'
import ImgFondoUsuario from 'assets/images/Img_Fondo_Usuario.jpg'
import logoSernaturGob from 'assets/images/logo-sernatur-gob.jpg'
import { useAuth } from 'context'
import API from 'api'
import { useHistory } from 'react-router-dom'
import Tooltip from '@material-ui/core/Tooltip'
import ErrorIcon from '@material-ui/icons/Error'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useMergedState } from 'hooks'
import { Button, VideoDialog } from 'components'
import Dialog from 'components/common/Dialog'

import { data } from './form'
const styleButton = (palette, spacing) => {
  return {
    backgroundColor: palette.error.light,
    border: `2px solid ${palette.error.light}`,
    color: palette.common.white,
    padding: spacing(1.5, 2),
    maxWidth: 190,
    borderRadius: 50,
  }
}

const useStyles = makeStyles(({ palette, spacing, fontSize, fontWeight, breakpoints }) => ({
  rootBase: {
    height: `calc(100vh - 137px)`,
    backgroundPosition: `center`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: `cover`,
    [breakpoints.down(`xs`)]: {
      height: `auto`,
    },
    [breakpoints.down(`md`)]: {
      height: `100vh`,
    },
  },
  providerImg: {
    backgroundImage: `url(${ImgFondoProveedor})`,
  },
  adminImg: {
    backgroundImage: `url(${ImgFondoUsuario})`,
  },
  content: {
    maxWidth: 1600,
    width: `90%`,
    [breakpoints.down(`sm`)]: {
      paddingBottom: spacing(3),
    },
  },
  containterTitle: {
    width: `100%`,
    backgroundColor: `#006CB8`,
    height: 43,
    borderRadius: `8px 8px 0px 0px`,
    [breakpoints.down(1450)]: {
      maxWidth: 710,
    },
  },
  noMargin: {
    margin: 0,
  },
  imageContainer: {
    width: 170,
    display: `flex`,
  },
  logoSernaturGob: {
    width: `270px`,
    height: `100%`,
  },
  formContainer: {
    width: `auto`,
    [breakpoints.down(1450)]: {
      maxWidth: `none`,
      width: `100%`,
      justifyContent: `center`,
    },
  },
  login: {
    padding: 50,
    background: `#ffffff8f`,
    width: `100%`,
    mixBlendMode: `normal`,
    opacity: `0.8`,
    border: `1px solid #E6EAEE`,
    boxSizing: `border-box`,
    boxShadow: `12px 8px 44px -12px rgba(127, 143, 164, 0.2)`,
    borderRadius: `0px 0px 8px 8px`,
    [breakpoints.down(1450)]: {
      maxWidth: 710,
    },
    [breakpoints.down(`md`)]: {
      padding: spacing(2, 4, 4, 4),
    },
  },
  button: {
    ...styleButton(palette, spacing),
    '&:hover': {
      color: palette.error.light,
      backgroundColor: palette.common.white,
    },
  },
  disabledButton: {
    backgroundColor: `${palette.error.dark} !important`,
    color: `${palette.common.white} !important`,
  },
  linkText: {
    fontSize: 14,
    color: `#006CB7`,
    textAlign: `center`,
    textDecoration: `underline`,
  },
  containerRecover: {
    marginTop: 20,
  },
  tooltipIcon: {
    fill: palette.success.main,
    width: 15,
    height: 15,
    [breakpoints.down(`md`)]: {
      margin: isAdmin => (isAdmin ? `none` : spacing(5, 0, 2, 0)),
    },
  },
}))

function Login() {
  const {
    location: { pathname },
  } = useHistory()
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down(`md`))
  const isAdmin = [`/admin`, `/admin/`].includes(pathname)
  const classes = useStyles(isAdmin)
  const [{ error }, setState] = useMergedState({
    error: false,
    tooltipState: {
      open: isMobile,
      placement: `top`,
    },
  })
  const [modal, setModal] = useState(false)
  const { fieldsById, sections } = data
  const { logIn } = useAuth()

  if (isAdmin) {
    delete fieldsById.forgot_password
  }

  const haddleOnCLick = async body => {
    setState({ error: false })
    const { email, password } = body
    try {
      const {
        data: { token, url },
      } = await new API({
        endpoint: isAdmin ? `signIn` : `signInProvider`,
        data: { email, password },
      }).send()
      logIn(token, url)
    } catch ({ message }) {
      setState({ error: message })
    }
  }

  async function tryLoginExt() {
    const urlFragments = pathname.split(`/`)
    const token = urlFragments[3]
    if (token) {
      const {
        data: { token: responseToken, url },
      } = await new API({
        endpoint: `loginExt`,
        data: { token },
      }).send()
      logIn(responseToken, url)
    }
  }
  useEffect(() => {
    const isAuthExt = pathname.includes(`/auth/ext/`)
    if (isAuthExt) {
      tryLoginExt()
    }
    setState({
      tooltipState: {
        open: isMobile,
        placement: isMobile ? `right` : `top`,
      },
    })
    // eslint-disable-next-line
  }, [isMobile])

  return (
    <>
      <Dialog
        open={modal}
        onClose={() => setModal(false)}
        hiddenButton={false}
        title="Video Tutorial"
        body={<VideoDialog />}
      />

      <AppBar position="static">
        <Toolbar>
          <Grid
            container
            md
            lg
            alignContent="center"
            justify="center"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            <Grid item container xs={11} sm={9} md={11} lg={9} xl={7}>
              <Grid item container xs={12} md={6} alignContent="flex-start" justify="flex-start">
                <img src={logoSernaturGob} alt="LogoSernaturGoB" width={182} height={100} />
              </Grid>
              <Grid
                item
                container
                sm={12}
                md={6}
                lg={6}
                justify="flex-end"
                alignItems="center"
                spacing={1}
              >
                <Grid item>
                  <Typography
                    title="¿No sabes como ingresar tu experiencia?"
                    size={16}
                    component="h3"
                  />
                </Grid>
                <Grid item>
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="primary"
                    onClick={() => setModal(true)}
                  >
                    Ver Tutorial
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Grid
        container
        className={`${isAdmin ? classes.adminImg : classes.providerImg} ${classes.rootBase}`}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid
          container
          xs={11}
          sm={11}
          md={11}
          lg={9}
          xl={7}
          alignContent="center"
          justify="center"
        >
          <Grid item container md={6}>
            <Grid item container sm={12} md={12} alignContent="flex-start" justify="flex-start">
              <Typography
                title="Bienvenido al Catálogo<br/> de Experiencias"
                size={40}
                sizeMovile={40}
                color="white"
                align="justify"
                weight="bold"
                component="h2"
              />
            </Grid>
            <Grid item container sm={12} md={12} justify="flex-start" alignItems="flex-end">
              <Typography
                title="*Se recomienda visualizar esta aplicación en <br/>computador de escritorio."
                size={16}
                color="white"
                align="justify"
                component="h2"
              />
            </Grid>
          </Grid>
          <Grid item md={6}>
            <Grid item container>
              <Grid container className={classes.formContainer}>
                <Grid
                  container
                  justify="center"
                  alignContent="center"
                  className={classes.containterTitle}
                >
                  <Grid item>
                    <Typography
                      title={isAdmin ? `USUARIO INTERNO` : `PROVEEDOR`}
                      size={14}
                      color="white"
                      align="center"
                      weight="bold"
                      component="h3"
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  className={classes.login}
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <Grid
                    item
                    container
                    justify={!isAdmin ? `space-between` : `center`}
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item container md lg style={{ marginBottom: 20 }}>
                      <Grid item md={11} lg={11}>
                        <Typography
                          title="Ingresa tus datos para iniciar sesión"
                          color="azul"
                          size={16}
                          weight="bold"
                          component="h3"
                          align="center"
                        />
                      </Grid>
                      <Grid item md={1} lg={1}>
                        {!isAdmin && (
                          <Tooltip title="Para poder ingresar debes utilizar el email y contraseña que utilizas para ingresar al Registro Nacional de Prestadores de Servicios Turísticos">
                            <ErrorIcon className={classes.tooltipIcon} />
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>

                    <Forms
                      classes={classes}
                      sections={isAdmin ? sections.fieldsIds.slice(0, 2) : sections.fieldsIds}
                      fieldsById={fieldsById}
                      submitForm={data => haddleOnCLick(data)}
                      error={error}
                      acceptText="¡INGRESA!"
                    />
                  </Grid>
                  {!isAdmin && (
                    <Grid item className={classes.containerRecover}>
                      <a
                        className={classes.linkText}
                        href={`https://registro.sernatur.cl/registroempresarios/registro`}
                        target={`_black`}
                        rel="noopener noreferrer"
                      >
                        Quiero registrarme
                      </a>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Login
